import { api } from '../../../axios';

export const fetchSurveys = async (token: string, clientId: string | number) => {
  const response = await api.get(
    `bx_block_survey/surveys?client_id=${clientId}`,
    { headers: { token } }
  );
  return response.data;
};
